import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';

export default class Villanameshow extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "villa";
	
  	}
	
    state = {

	
        name: "villa",
       respdata: null,   
       url: "",
      vnm:"villa",
 	
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
        
	this.setvilla();
    }
 
setvilla(){
       
         const vn = Usersession.getVillaname();
          
         
	 this.setState({ vnm: vn });

}
    
 render() {

   
     return (

        
	<div className="per100" id="topvillaname">
	 {this.state.vnm}
	</div>
   	
    
   
      );
}
}

